/**
 * The UI locales the platform ships in. The same six codes are hard-coded in three
 * places which have to agree, so treat this as the frontend's single reference point:
 *
 * - Transloco's `availableLangs` (`libs/angular-translations/src/lib/transloco-root.module.ts`)
 * - `LanguageService._availableLanguages` (the language picker)
 * - the backend's `Accept-Language` matcher, which resolves translatable text and
 *   reports coverage in `translated_locales` (see `docs/insights-payload.md`)
 *
 * Not to be confused with `TranslationService.availableTranslationSourceLanguageCodes`,
 * which is the much longer list of languages DeepL can translate from.
 */
export type SupportedLocale = 'de' | 'en' | 'es' | 'fr' | 'nl' | 'sl';

export const SUPPORTED_LOCALES: readonly SupportedLocale[] = ['de', 'en', 'es', 'fr', 'nl', 'sl'];

/**
 * Narrows a plain string — an `AvailableLanguage.languageKey` or a `Language.iso`, both
 * typed `string` — to a `SupportedLocale`, so it can be checked against locale lists.
 */
export function isSupportedLocale(value: string | null | undefined): value is SupportedLocale {
  return !!value && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
